import {
  SegmentedControlProps,
  SelectProps,
} from "@amzn/awsui-components-react";
import * as awsui from "@amzn/awsui-design-tokens/polaris";
import { Stage } from "./lusca-search-api/generated-src";

const BASE_16_CLOUDSCAPE_THEME = {
  base00: awsui.colorBackgroundCodeView,
  base01: awsui.colorBackgroundCodeView,
  base02: awsui.colorBorderDividerDefault,
  base03: awsui.colorTextBodySecondary,
  base04: awsui.colorTextBodySecondary,
  base05: awsui.colorTextBodyDefault,
  base06: awsui.colorTextBodyDefault,
  base07: awsui.colorTextBodyDefault,
  base08: awsui.colorTextStatusError,
  base09: awsui.colorTextStatusSuccess,
  base0A: awsui.colorTextStatusError,
  base0B: awsui.colorTextStatusSuccess,
  base0C: awsui.colorTextStatusInfo,
  base0D: awsui.colorTextBodySecondary,
  base0E: awsui.colorTextStatusInfo,
  base0F: awsui.colorTextStatusInfo,
};

const LIGHT_THEME = "light";
const DARK_THEME = "dark";

export const STAGE_OPTIONS: SelectProps.Option[] = Object.values(Stage).map(
  (s) => ({ label: s, value: s })
);

export const DEFAULT_STAGE = Stage.Prod;

/**
 * Stages the DLQ dashboard and investigations page offer (not Beta), in switcher order.
 * One list so the dashboard and the investigations page cannot drift.
 */
export const DLQ_STAGES: readonly Stage[] = [Stage.Prod, Stage.Gamma];

export const DLQ_STAGE_SEGMENTS: SegmentedControlProps.Option[] =
  DLQ_STAGES.map((stage) => ({ id: stage, text: stage }));

export const DESTINATION_OPTIONS: SelectProps.Option[] = [
  { label: "Flare", value: "FLARE" },
  { label: "rACE", value: "RACE" },
  { label: "None", value: "NONE" },
];

export const DIFF_UNCHANGED_LINES_CONFIG = {
  threshold: 5,
  margin: 3,
  expandMoreLinesLimit: 5,
};

const PERMISSION_LINK =
  "https://permissions.amazon.com/a/team/amzn1.abacus.team.nxghcmvq7dyzqkzpwd5a";

const EMP_PROVIDERS = {
  APPLE: "amzn1.emp.provider.apple-partner-billing",
  GOOGLE: "amzn1.emp.provider.google-in-app",
  FUSE: "amzn1.emp.provider.fuse",
} as const;

const PAYMENT_METHODS = {
  APPLE: "Apple",
  GOOGLE: "Google",
  FUSE: "Fuse",
  EMP: "EMP",
  DIRECT_DEBIT: "Direct Debit",
  AMP: "AMP",
  CREDIT_CARD: "Credit Card",
  PAY_BY_BANK: "PayByBank",
  BANCONTACT: "Bancontact",
  PIX: "PIX",
  BLIK: "BLIK",
  BIZUM: "Bizum",
  IDEAL: "iDEAL",
} as const;

/**
 * Maps country codes to the local payment method name when the instrument is
 * "UnmappedPaymentInstrument". These are marketplace-specific direct debit
 * variants that FOIL doesn't resolve to a named instrument.
 * Unmapped countries continue to show the raw instrument string.
 */
const UPI_COUNTRY_TO_PAYMENT_METHOD: Record<string, string> = {
  GB: PAYMENT_METHODS.PAY_BY_BANK,
  BE: PAYMENT_METHODS.BANCONTACT,
  BR: PAYMENT_METHODS.PIX,
  PL: PAYMENT_METHODS.BLIK,
  ES: PAYMENT_METHODS.BIZUM,
  NL: PAYMENT_METHODS.IDEAL,
};

const EMP_TO_PAYMENT_METHOD: Record<string, string> = {
  [EMP_PROVIDERS.APPLE]: PAYMENT_METHODS.APPLE,
  [EMP_PROVIDERS.GOOGLE]: PAYMENT_METHODS.GOOGLE,
  [EMP_PROVIDERS.FUSE]: PAYMENT_METHODS.FUSE,
};

const DIGITAL_ORDER_SOURCES = {
  ARK: "ARK",
  FOIL: "FOIL",
} as const;

export {
  BASE_16_CLOUDSCAPE_THEME,
  LIGHT_THEME,
  DARK_THEME,
  PERMISSION_LINK,
  EMP_PROVIDERS,
  PAYMENT_METHODS,
  EMP_TO_PAYMENT_METHOD,
  DIGITAL_ORDER_SOURCES,
  UPI_COUNTRY_TO_PAYMENT_METHOD,
};
